module.exports = __webpack_public_path__ + "img/plus-orange.5d496c43.svg";